var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolomonMo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67818 3.35258H13.4472C13.0942 2.1656 12.535 1.02799 11.7691 0H0C0.765942 1.02799 1.3251 2.1656 1.67818 3.35258Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8672 8.76552L6.05148 8.76044C7.16698 8.72995 8.23536 8.29073 9.06671 7.52192C9.89736 8.29073 10.9664 8.72995 12.082 8.76044L12.2662 8.76552L12.1453 10.0113H14.6435C15.2554 8.2312 15.3926 6.32042 15.0543 4.48151H1.94887C2.39268 6.8954 2.01779 9.43488 0.824219 11.6368H6.14572L5.8679 8.76552H5.8672Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0195 11.3028L11.9766 11.7457C11.9365 12.1566 11.838 12.5544 11.6875 12.9283C11.4301 13.5664 11.0208 14.1349 10.4883 14.5755L9.06616 15.7516L7.644 14.5755C7.11157 14.1349 6.70222 13.5664 6.4448 12.9283H0.019043L3.34516 18H14.0669V17.9818L18 11.3028H12.0195Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.9271H0.0189753L0.00983906 12.9138C0.00632511 12.918 0.00351395 12.9229 0 12.9271Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8992L0.00983906 12.914C0.013353 12.9091 0.016867 12.9041 0.0210837 12.8992H0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolomonMo);
export default __webpack_public_path__ + "static/media/solomonMo.11a1789859464dd6ca4bfba651601fda.svg";
export { ForwardRef as ReactComponent };